var render = function render(){var _vm=this,_c=_vm._self._c;return (!isNaN(_vm.value))?_c('span',{class:_vm.colorClass},[_c('span',{staticClass:"fw-500"},[_vm._v("\n    "+_vm._s(_vm.plusMinus)+_vm._s(_vm.value)+"%\n  ")]),_vm._v(" "),_c('v-icon',{staticClass:"fs-13r",class:_vm.colorClass},[_vm._v("\n    "+_vm._s(_vm.icon)+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }